import { LoadingOutlined } from '@ant-design/icons'
import React from 'react'

function Button({children, loading, type='', icon, disabled, className='', htmlType='button', iconClass='', iconPosition='left', size='sm', ...restProps}) {

  const renderButton = () => {
    switch (type) {
      case 'primary': return (
        <button 
          style={
            size === 'sm' ? 
            {padding: icon && !children ? '8px' : '6px  10px', borderRadius: '6px', fontSize: '14px', lineHeight: 'normal'} :
            {padding: '8x 12px', borderRadius: '6px', fontSize: '14px', lineHeight: 'normal'}
          } 
          className={`primary-button ${className}`}
          disabled={loading ? loading : disabled}
          {...restProps} 
          type={htmlType}
        >
          <div className='flex items-center justify-center'>
            {
              iconPosition === 'left' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'mr-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'w-[14px] mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              ) 
            }
            {children}
            {
              iconPosition === 'right' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'ml-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'w-[14px] mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              )
            }
          </div>
        </button>
      )
      case 'success': return (
        <button 
          style={
            size === 'sm' ? 
            {padding: icon && !children ? '8px' : '8px  12px', borderRadius: '6px', fontSize: '14px', lineHeight: 'normal'} :
            {padding: '12px 24px', borderRadius: '8px', fontSize: '16px', lineHeight: 'normal'}
          } 
          className={`success-button ${className}`}
          disabled={loading ? loading : disabled}
          {...restProps} 
          type={htmlType}
        >
          <div className='flex items-center justify-center'>
            {
              iconPosition === 'left' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'mr-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'w-[14px] mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              ) 
            }
            {children}
            {
              iconPosition === 'right' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'ml-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'w-[14px] mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              )
            }
          </div>
        </button>
      )
      case 'text': return (
        <button 
          style={
            size === 'sm' ? 
            {padding: icon && !children ? '8px' : '8px  12px', borderRadius: '6px', fontSize: '14px', lineHeight: 'normal'} :
            {padding: '12px 24px', borderRadius: '8px', fontSize: '16px', lineHeight: 'normal'}
          } 
          className={`text-button ${className}`} 
          disabled={loading ? loading : disabled} 
          {...restProps} 
          type={htmlType}
        >
          <div className='flex items-center justify-center'>
            {
              iconPosition === 'left' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'mr-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'w-[14px] mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              ) 
            }
            {children}
            {
              iconPosition === 'right' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'ml-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'w-[14px] mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              )
            }
          </div>
        </button>
      )
      case 'dash': return (
        <button 
          style={
            size === 'sm' ? 
            {padding: icon && !children ? '8px' : '8px  12px', borderRadius: '6px', fontSize: '14px', lineHeight: 'normal'} :
            {padding: '12px 24px', borderRadius: '8px', fontSize: '16px', lineHeight: 'normal'}
          } 
          className={`dash-button ${className}`} 
          disabled={loading ? loading : disabled} 
          {...restProps} 
          type={htmlType}
        >
          <div className='flex items-center justify-center'>
            {
              iconPosition === 'left' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'mr-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'w-[14px] mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              ) 
            }
            {children}
            {
              iconPosition === 'right' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'ml-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'w-[14px] mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              )
            }
          </div>
        </button>
      )
      case 'ghost': return (
        <button 
          style={
            size === 'sm' ? 
            {padding: icon && !children ? '8px' : '8px  12px', borderRadius: '6px', fontSize: '14px', lineHeight: 'normal'} :
            {padding: '12px 24px', borderRadius: '8px', fontSize: '16px', lineHeight: 'normal'}
          } 
          className={`ghost-button ${className}`} 
          disabled={loading ? loading : disabled} 
          {...restProps} 
          type={htmlType}
        >
          <div className='flex items-center justify-center'>
            {
              iconPosition === 'left' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'mr-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              ) 
            }
            {children}
            {
              iconPosition === 'right' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'ml-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              ) 
            }
          </div>
        </button>
      )
      case 'danger': return (
        <button 
          style={
            size === 'sm' ? 
            {padding: icon && !children ? '8px' : '8px  12px', borderRadius: '6px', fontSize: '14px', lineHeight: 'normal'} :
            {padding: '12px 24px', borderRadius: '8px', fontSize: '16px', lineHeight: 'normal'}
          } 
          className={`danger-button ${className}`} 
          disabled={loading ? loading : disabled} 
          {...restProps} 
          type={htmlType}
        >
          <div className='flex items-center'>
            {
              iconPosition === 'left' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'mr-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              ) 
            }
            {children}
            {
              iconPosition === 'right' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'ml-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              ) 
            }
          </div>
        </button>
      )
      default: return (
        <button 
          style={
            size === 'sm' ? 
            {padding: icon && !children ? '8px' : '8px  12px', borderRadius: '6px', fontSize: '14px', lineHeight: 'normal'} :
            {padding: '12px 24px', borderRadius: '8px', fontSize: '16px', lineHeight: 'normal'}
          } 
          className={`default-button ${className}`} 
          disabled={loading ? loading : disabled} 
          {...restProps} 
          type={htmlType}
        >
          <div className='flex items-center justify-center'>
            {
              iconPosition === 'left' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'mr-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              )
            }
            {children}
            {
              iconPosition === 'right' &&
              (
                icon ?
                <div className={`flex overflow-hidden ${children ? 'ml-2' : ''}`}>
                  {loading ? <LoadingOutlined/> : icon} 
                </div>  
                :
                <div className={`flex overflow-hidden transition-all ${loading ? 'mr-2' : 'w-0'}`}>
                  <LoadingOutlined/> 
                </div>
              )
            }
          </div>
        </button>
      )
    }
  }
  return renderButton()
}

export default Button